<script>
    import moment from 'moment';

    export default {
        props: [
            'add'
        ],
        components: {
            filecounter: require('./mediapool/filecounter.vue').default,
            list: require('./mediapool/mediapoolList.vue').default,
            search: require('./mediapool/search.vue').default,
            addMediaModal: require('./mediapool/add-media-modal.vue').default,
            showMediaModal: require('./mediapool/show-media-modal.vue').default,
            deleteMediaModal: require('./mediapool/delete-media-dialog.vue').default,
            editMediaModal: require('./mediapool/edit-media-modal.vue').default,
            screenMediapool: require('./mediapool/screen-mediapool.vue').default,
        },
        data: function () {
            return {
                files: [],
                folders: [],
                searchData: {},
                folder: null,
                quota: '',
                over_quota: false,
                loading: true,
                multiSelect: false,
                mode: 'tiles',
                sort_by: '',
                sort_dir: 'asc',
                date_format_mapping: {
                    'dd.MM.yyyy': 'DD.MM.yyyy hh:mm:ss',
                    'MM/dd/yyyy': 'MM.DD.yyyy hh:mm:ss'
                }
            }
        },
        methods: {
            fetchMedia: function (data) {
                let keyword = '',
                    tags = '',
                    folder = '',
                    types = '';
                this.loading = true;
                this.files = [];

                this.searchData = data;
                if (data && typeof data === 'object') {
                    keyword = data.keyword;
                    tags = data.tags;
                    types = data.types;
                }

                folder = this.folder;

                axios.post('/content/mediapool/get', {
                    id: Laravel.activeProject,
                    keyword: keyword,
                    tags: tags,
                    folder: folder,
                    types: types,
                    show_past: true,
                    show_future: true
                }).then((response) => {
                    this.loading = false;
                    this.multiSelect = false;
                    this.files = response.data.data.media;
                    this.folders = response.data.data.folders;
                    this.quota = response.data.data.quota;
                    this.over_quota = response.data.data.over_quota;
                    this.sortMedia();
                }).catch((error) => {
                    this.loading = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    $('.load-media-notifications .alert').addClass('hidden');
                    $('.load-media-notifications .alert-danger').removeClass('hidden');
                });
            },
            sortMedia: function (data=null) {
                if(data) {
                    this.sort_by = data.sort_by;
                    this.sort_dir = data.sort_dir;
                }
                this.files.sort((media1, media2) => {
                    var val1, val2;
                    if (this.sort_by === 'date') {
                        let currentDateFormat = this.date_format_mapping[Laravel.activeDateformat];
                        val1 = parseInt(moment(media1.created_at, currentDateFormat).unix(), 10);
                        val2 = parseInt(moment(media2.created_at, currentDateFormat).unix(), 10);
                    } else if (this.sort_by === 'type') {
                        val1 = media1.file_extension + " " + media1.display_name.toLowerCase();
                        val2 = media2.file_extension + " " + media2.display_name.toLowerCase();
                    } else if (this.sort_by === 'size') {
                        val1 = media1.media_size;
                        val2 = media2.media_size;
                    } else {
                        val1 = media1.display_name.toLowerCase();
                        val2 = media2.display_name.toLowerCase();
                    }
                    var retVal = 0;
                    if(val1 > val2)
                        retVal = this.sort_dir === 'desc' ? -1 : 1;
                    else if(val1 < val2)
                        retVal = this.sort_dir === 'desc' ? 1 : -1;

                    return retVal;
                });
            }
        },
        mounted() {
            this.fetchMedia();
            this.mode = localStorage.getItem('mediapool-mode-' + Laravel.activeProject) ?? 'tiles';

            if(this.add === '1') {
                this.$nextTick(function() {
                    EaseEventBus.fire('showAddMediaModal');
                });
            }

            EaseEventBus.listen('startSearch', (data) => {
                this.fetchMedia(data);
            });

            EaseEventBus.listen('sortBy', (data) => {
                this.sortMedia(data);
            });

            EaseEventBus.listen('updateMedialistData', (data) => {
                this.fetchMedia(data);
            });

            EaseEventBus.listen('enter-folder', (folderId) => {
                this.folder = folderId;
                this.fetchMedia(this.searchData)
            })

            EaseEventBus.listen('selectMedia', () => {
                this.$nextTick(() => {
                    this.multiSelect = $(".mediapool-list .media-card.selected, .mediapool-list .mediapool-file-list .row.selected").length > 0;
                });
            });

            EaseEventBus.listen('mediapoolMode', (mode) => {
                this.mode = mode;
                localStorage.setItem('mediapool-mode-' + Laravel.activeProject, mode);
            });

            EaseEventBus.listen('mediapoolMultiSelect', (mode) => {
                this.multiSelect = mode; //true => select; false => unselect
                var media = $(".mediapool-list .media-file." + (mode ? 'no-selection' : 'selected'));

                $.each(media, function (index, value) {
                    if (mode === true) {
                        $(value).removeClass('no-selection');
                        $(value).addClass('selected');
                    } else {
                        $(value).addClass('no-selection');
                        $(value).removeClass('selected');
                    }
                });
            });
        }
    }
</script>
